import { redirect } from "react-router-dom";
import { AuthError } from "@/types/errorTypes/authError";
import { apiEndpoints } from "@/services/api/api.ts";
import { AdminPanelCategoryCreateData } from "@/routes/adminPanel/categories/create/types/adminPanelCategoryCreateData.ts";

export const adminPanelCategoryCreateAction = async ({
  request,
}: {
  request: Request;
}) => {
  const formData = await request.formData();
  const data = Object.fromEntries(
    formData,
  ) as unknown as AdminPanelCategoryCreateData;
  try {
    const url = new URL(request.url);
    const returnUrl =
      url.searchParams.get("returnUrl") || "/admin-panel/categories";

    const categoryUpdateResult = await apiEndpoints.createCategory(data);
    if (categoryUpdateResult.success) {
      return redirect(returnUrl);
    }
    return true;
  } catch (err) {
    throw err;
  }
};
